import type {ListClientsSearch} from "../-types";

import {PageContainerSkeleton, TableSkeleton, ToolbarSkeleton} from "@project/components/feedback";

import {clientsRouteApi} from "../-route-api";

export function ClientsPending() {
  const search = clientsRouteApi.useSearch() as ListClientsSearch;
  const perPage = search.perPage ?? 20;

  return (
    <PageContainerSkeleton>
      <ToolbarSkeleton>
        <div className="flex w-full gap-3 @lg:w-auto">
          <div className="flex-1 @lg:flex-none">
            <ToolbarSkeleton.Input />
          </div>
          <div className="hidden @lg:inline-flex">
            <ToolbarSkeleton.Button />
          </div>
          <div className="flex @lg:hidden">
            <ToolbarSkeleton.Button className="w-10" />
          </div>
        </div>
      </ToolbarSkeleton>

      <TableSkeleton columns={6} rows={perPage} />
    </PageContainerSkeleton>
  );
}
